export const NY_APPROVED = 'NY Approved'
